import React, { useContext, useEffect, useState } from 'react';
import styles from './canvasbuttonslist.module.css';
import { DownloadIcon, WebIcon } from '../../../Icons';
import JsPDF from 'jspdf';
import { canvasHandFrameDataContext } from '../../../context/canvasHandFrameDataContext';
import { canvasTextureContext } from '../../../context/canvasTextureContext';
import { canvasBackgroundContext } from '../../../context/canvasBackgroundContext';
import { canvasModeContext } from '../../../context/canvasModeContext';
import { canvasTotalPriceContext } from '../../../context/canvasTotalPriceContext';
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';
import { PTSans } from '../../../fonts/PTSans';
import { canvasOptionsContext } from '../../../context/canvasOptionsContext';
import { OptionNames } from '../../../types/namesList';
import { Box, Modal } from "@mui/material";
import { AddToBasket } from "../../OptionsContainer/Buttons/AddToBasket";
import axios from "axios";
import { collectionsContext } from "../../../context/collectionsContext";

interface ICanvasButtonsList {
    onFlipClick: (newIsFlipped: boolean) => void;
    isFlipped: boolean;
    gridCnt: number;
    dragX?: number;
}

export function CanvasButtonsList(props: ICanvasButtonsList) {
    const { gridCnt, dragX } = props;

    const { imgData } = useContext(canvasTextureContext);
    const { backgroundData } = useContext(canvasBackgroundContext);
    const { handFrameData } = useContext(canvasHandFrameDataContext);
    const { options } = useContext(canvasOptionsContext);
    const { mode, isSeamless, isSigned } = useContext(canvasModeContext);
    const { price } = useContext(canvasTotalPriceContext);
    const [buyButtonText, setBuyButtonText] = useState('Добавить в корзину')
    const [modalOpen, setModalOpen] = useState(false);
    const [addingToBasket, setAddingToBasket] = useState(false);
    const { collectionsData } = useContext(collectionsContext);

    const weblinkHandframeData = {
        ...handFrameData,
        height: Math.round(handFrameData.height),
        width: Math.round(handFrameData.width)
    }

    const makeWebLink = () => {
        const selectedOptions = document.getElementsByClassName('js-selected-option');
        const hiddenOptions = document.getElementsByClassName('js-hidden-option');

        const arOptions: string[] = [];
        [].forEach.call(selectedOptions, function (el: HTMLElement) {
            arOptions.push(el.innerHTML);
        });

        const arHidden: string[] = [];
        [].forEach.call(hiddenOptions, function (el: HTMLElement) {
            arHidden.push(el.innerHTML);
        });

        const exampleOption = options?.items.find(option => option.name === OptionNames.Example);

        const name = document.getElementById('element_name_selected')?.innerHTML,
            img = imgData.img,
            background = backgroundData.img,
            backgroundName = backgroundData.name,
            imgPrice = imgData.price,
            backgroundPrice = backgroundData.price,
            groupName = backgroundData.backgroundColor ? 'Цвет заказчика' : backgroundData.groupName,
            seamless = arOptions.indexOf(OptionNames.Seamless) > -1,
            standartSizes = arOptions.indexOf(OptionNames.StandartSizes) > -1,
            signature = arOptions.indexOf(OptionNames.Signature) > -1,
            varnish = arOptions.indexOf(OptionNames.Varnish) > -1,
            install = arOptions.indexOf(OptionNames.Install) > -1,
            example = exampleOption && exampleOption.isSet && exampleOption.isExtraPrice
                ? 'big'
                : arOptions.indexOf(OptionNames.Example) > -1,
            isFlipped = arOptions.indexOf(OptionNames.ToMirror) > -1,
            urgency = arOptions.indexOf(OptionNames.Urgency) > -1,
            TDImage = arOptions.indexOf(OptionNames.ThreeDimensionImage) > -1,
            hidden = arHidden.join(','),
            weblinkDragX = dragX !== undefined ? dragX : '0';
        let params =
            'itemId=' + collectionsData.elementId +
            '&sectionId=' + Number(collectionsData.sectionId) +
            '&name=' + name +
            '&img=' + img +
            '&background=' + background +
            '&backgroundName=' + backgroundName.replace('#', '%23') +
            '&imgPrice=' + imgPrice +
            '&backgroundPrice=' + backgroundPrice +
            '&groupName=' + groupName +
            '&mode=' + mode +
            '&isSeamless=' + isSeamless +
            '&isSigned=' + isSigned +
            '&gridCnt=' + gridCnt +
            '&dragX=' + weblinkDragX +
            '&handFrame=' + JSON.stringify(weblinkHandframeData) +
            '&seamless=' + seamless +
            '&standartSizes=' + standartSizes +
            '&signature=' + signature +
            '&varnish=' + varnish +
            '&install=' + install +
            '&example=' + example +
            '&isFlipped=' + isFlipped +
            '&hidden=' + hidden +
            '&urgency=' + urgency +
            '&3DImage=' + TDImage
        ;

        // const ajaxMode = window.location.hostname === 'localhost';
        const ajaxMode = (document.getElementById('constructor_app') as HTMLDivElement)?.getAttribute('data-set-ajax-mode') === 'true' || window.location.hostname === 'localhost';

        // if(ajaxMode) {
        //     const curUrl = new URL(window.location.href);
        //     params = `SECTION_ID=${curUrl.searchParams.get("SECTION_ID")}&` + params;
        // }

        return encodeURI(window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + params);
    };

    const handleMakeWebLink = () => {
        const weblink = makeWebLink();

        navigator.clipboard.writeText(weblink).then(
            function () {
                setModalOpen(true);
            },
            function (err) {
                const text = `Ошибка, ссылка ${weblink} НЕ скопирована в буфер обмена`;
                alert(text);
            },
        );
    };

    const handleMakeWebLinkToDataAttr = () => {
        const weblink = makeWebLink(),
            element = document.getElementById('element');
        if(element) element.setAttribute('data-weblink', weblink);
    };

    const modalClose = () => {
        setModalOpen(false);
    }

    let optionsDataStringForPdf = '';

    options?.items.forEach(option => {
        if(option.name === OptionNames.Example && option.isExtraPrice) {
            optionsDataStringForPdf += `${option.name} : ${option.isSet ? '55x45' : 'нет'}\n`;
        } else if(option.name === OptionNames.Example && !option.isExtraPrice) {
            optionsDataStringForPdf += `${option.name} : ${option.isSet ? 'a4' : 'нет'}\n`;
        } else {
            optionsDataStringForPdf += `${option.name} : ${option.isSet ? 'да' : 'нет'}\n`;
        }
    });

    const handleMakePDF = async (isDownload: boolean) => {
        const input = document.getElementsByClassName('js-canvas-pdf')[0],
            weblink = makeWebLink(),
            dateObj = new Date(),
            dd = String(dateObj.getDate()).padStart(2, '0'),
            mm = String(dateObj.getMonth() + 1).padStart(2, '0'), //January is 0!
            yyyy = dateObj.getFullYear(),
            curDate = dd + '.' + mm + '.' + yyyy + ' ' + dateObj.getHours() + ':' + dateObj.getMinutes(),
            imgName = imgData.items.find(item => item.img == imgData.img)!.id,
            warningText =
                '*ВНИМАНИЕ! Без подписи заказ в производство не запускается!\n' +
                'Внимательно проверьте размеры и комплектацию. Данный чертеж является документом, по которому будет выполняться заказ. ' +
                'Перед самостоятельной поклейкой обязательно ознакомьтесь с инструкцией на сайте. Приведенная иллюстрация не воспроизводит точный цвет. ' +
                'Цвет утверждается только на образце. После уточнения технического задания цена может измениться. ' +
                'Заказчик осведомлен, что чертеж и финальная работа могут различаться по композиционным, цветовым и прочим характеристикам (кроме указанных размеров стены). ' +
                'Это обусловлено характером ручной работы и в этом заключается эксклюзивность каждого изделия. ' +
                'Это не является дефектом и не может служить основанием к претензиям. ' +
                'Заказчик осведомлен, что видимые швы на стыках полотен не являются дефектом продукции или неудовлетворительной работой при поклейке полотен. ' +
                'Стоимость монтажа рассчитана из стандартных условий, возможна наценка за фигурные подрезы сложных элементов, поклейку обоев в рамки, поклейку обоев на потолок и других условий. ' +
                'Изображение дано для использования в архитектурных проектах. Нелицензионное копирование изображений преследуется законом.'
            ,
            infoData =
                `Название: ${imgData.items[0].name}\n` +
                `Цвет: ${imgName}\n` +
                `Фон: ${backgroundData.name.replace('%23', '#')}\n` +
                `Размеры: ${Math.round(handFrameData.width)} см на ${Math.round(handFrameData.height)} см\n` +
                `Площадь: ${Math.round((handFrameData.width * handFrameData.height) / 100) / 100} м2\n` +
                `Цена: ${price} р.`,
            optionsData = 'ОПЦИИ:\n' + optionsDataStringForPdf
        return await html2canvas(input as HTMLElement).then(canvas => {
            const imgDataBase64 = canvas.toDataURL('image/png'),
                unit = 'px',
                size = 'A4',
                orientation = 'landscape',
                marginLeft = 40,
                pdf = new JsPDF(orientation, unit, size),
                logoImage =
                    'data:image/jpg;base64,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';
            pdf.addFileToVFS('PTSans-normal.ttf', PTSans);
            pdf.addFont('PTSans-normal.ttf', 'PTSans', 'normal');
            pdf.setFont('PTSans');
            pdf.setFontSize(10);
            pdf.addImage(logoImage, 'jpg', marginLeft, 10, 120, 9);
            pdf.text(curDate, marginLeft + 500, 10);

            const imageHeight = (540 * canvas.height) / canvas.width;

            pdf.addImage(imgDataBase64, 'JPEG', marginLeft + 25, 20, 540 / 1.1, imageHeight / 1.1);

            autoTable(pdf, {
                theme: 'grid',
                styles: {
                    lineColor: '#333333',
                    font: 'PTSans',
                },
                startY: 260,
                body: [
                    [
                        {
                            content: 'Чертеж утвержден\n' + 'Подпись заказчика*\n' + '\n' + '\n' + '\n' + '\n' + '---------------',
                            rowSpan: 2,
                            colSpan: 1,
                            styles: { valign: 'middle', halign: 'center', cellWidth: 80 },
                        },
                        {
                            content: infoData,
                            colSpan: 1,
                            styles: { fontSize: 8, minCellWidth: 150 },
                        },
                        {
                            content: optionsData,
                            colSpan: 1,
                            styles: { fontSize: 8, minCellWidth: 150, minCellHeight: 80 },
                        },
                        {
                            content: 'Веб ссылка:\n' + weblink,
                            colSpan: 1,
                            styles: { fontSize: 5 },
                        },
                    ],
                    [
                        {
                            content: warningText,
                            colSpan: 3,
                            styles: { fontSize: 7 },
                        },
                    ],
                ],
            });

            pdf.setFontSize(10);
            pdf.setTextColor('#5a5860');

            pdf.textWithLink('Перейти по ссылке =>', 414, 330, { url: weblink });

            const base = pdf.output('datauristring').replace('data:application/pdf;filename=generated.pdf;base64,', ''); // base64 string

            if(isDownload) pdf.save(imgData.items[0].name + '.pdf');
            // return imgDataBase64;
            return base;
        });

    };

    const addToCart = async (imgData: any, event: MouseEvent) => {
        if((event.target as HTMLDivElement)!.classList.contains('disabled')) return;
        (event.target as HTMLDivElement)!.classList.add('disabled');
        setAddingToBasket(true);
        const formData = new FormData();

        await handleMakePDF(false).then((imgDataBase64) => {
            formData.append('PDF', imgDataBase64);

            const templatePath = document.getElementById('constructor_app')?.getAttribute('data-site-template-path')
                ? document.getElementById('constructor_app')?.getAttribute('data-site-template-path')
                : 'https://fresq.ru/local/templates/fresq';
            const curUrl = new URL(window.location.href),
                cartItemId = curUrl.searchParams.get("cartItemId");
            const weblink = makeWebLink().split('&');
            const texture = imgData.items.find((item: any) => item.img == imgData.img)?.id;
            // const elementId = collectionsData.elementId ? collectionsData.elementId : (document.getElementById('constructor_app') as HTMLDivElement)?.getAttribute('data-element-id') ?? 1006;
            const elementId = collectionsData.elementId;

            // const ajaxMode = (document.getElementById('constructor_app') as HTMLDivElement)?.getAttribute('data-set-ajax-mode') === 'true';
            const data = {
                ID: elementId,
                CART_ITEM_ID: cartItemId ? cartItemId : 0,
                // WEBLINK_MAIN: ajaxMode ? weblink[0] + `&SECTION_ID=${curUrl.searchParams.get("SECTION_ID")}&` : weblink[0] + '&',
                WEBLINK_MAIN: weblink[0] + '&' + weblink[1] + '&' + weblink[2] + '&',
                WEBLINK_IMG: weblink[3] + '&',
                WEBLINK_BACKGROUND: weblink[4] + '&',
                WEBLINK_BACKGROUND_NAME: weblink[5] + '&',
                WEBLINK_IMG_PRICE: weblink[6] + '&',
                WEBLINK_BACKGROUND_PRICE: weblink[7] + '&',
                WEBLINK_GROUP_NAME: weblink[8] + '&',
                WEBLINK_MODE: weblink[9] + '&',
                WEBLINK_IS_SEAMLESS: weblink[10] + '&',
                WEBLINK_IS_SIGNED: weblink[11] + '&',
                WEBLINK_GRID_CNT: weblink[12] + '&',
                WEBLINK_DRAG_X: weblink[13] + '&',
                WEBLINK_HANDFRAME: weblink[14] + '&',
                WEBLINK_SEAMLESS: weblink[15] + '&',
                WEBLINK_STANDART_SIZES: weblink[16] + '&',
                WEBLINK_SIGNATURE: weblink[17] + '&',
                WEBLINK_VARNISH: weblink[18] + '&',
                WEBLINK_INSTALL: weblink[19] + '&',
                WEBLINK_EXAMPLE: weblink[20] + '&',
                WEBLINK_FLIPPED: weblink[21] + '&',
                WEBLINK_HIDDEN: weblink[22] + '&',
                WEBLINK_URGENCY: weblink[23] + '&',
                WEBLINK_TDIMAGE: weblink[24],
                PRICE: price,
                TEXTURE: texture,
                BACKGROUND: backgroundData.groupName + ' '
                    + backgroundData.name ?? '',
                SIZE: Math.round(handFrameData.width) + 'cm x ' + Math.round(handFrameData.height) + 'cm = '
                    + (handFrameData.width / 100 * handFrameData.height / 100).toFixed(2) + ' m2',
                SEAMLESS: options?.items.find(item => item.name == 'Бесшовное полотно')?.isSet ? 'Да' : 'Нет',
                INDSIZE: options?.items.find(item => item.name == 'Нестандартные размеры')?.isSet ? 'Да' : 'Нет',
                SIGNATURE: options?.items.find(item => item.name == 'Подпись художника')?.isSet ? 'Да' : 'Нет',
                VARNISH: options?.items.find(item => item.name == 'Покрытие лаком')?.isSet ? 'Да' : 'Нет',
                WALLPAPPERING: options?.items.find(item => item.name == 'Монтаж')?.isSet ? 'Да' : 'Нет',
                SAMPLE: options?.items.find(item => item.name == 'Образец')?.isSet && options?.items.find(item => item.name == 'Образец')?.isExtraPrice
                    ? '55x45'
                    : options?.items.find(item => item.name == 'Образец')?.isSet && !options?.items.find(item => item.name == 'Образец')?.isExtraPrice
                        ? 'A4'
                        : 'Нет',
                MIRRORED: options?.items.find(item => item.name == 'Отзеркалить')?.isSet ? 'Да' : 'Нет',
                TDIMAGE: options?.items.find(item => item.name == 'Объемный рисунок')?.isSet ? 'Да' : 'Нет',
                URGENCY: options?.items.find(item => item.name == 'Срочность')?.isSet ? 'Да' : 'Нет',
                COMMENT: (document.getElementById('constructor_comment') as HTMLTextAreaElement)?.value,
            };

            formData.append('data', JSON.stringify(data));

            axios({
                method: 'POST',
                url: encodeURI(`${templatePath}/components/bitrix/catalog.element/fresq_element_detail/ajax/add_to_cart_new.php`),
                data: formData
            })
                .then(response => {
                    if(response.data) {
                        (event.target as HTMLDivElement)!.classList.remove('disabled');
                        setBuyButtonText('Перейти в корзину');
                        if(document.getElementById('cart-count') && !cartItemId) (document.getElementById('cart-count') as HTMLDivElement).innerHTML = (+(document.getElementById('cart-count') as HTMLDivElement).innerHTML + 1).toString();
                    }
                    setAddingToBasket(false);
                    return;
                })
                .catch(function (error) {
                    (event.target as HTMLDivElement)!.classList.remove('disabled');
                    setAddingToBasket(false);
                    console.log(error)
                });
        });
    }

    useEffect(() => {
        const handleClick = (event: MouseEvent) => {
            if(event.target && (event.target as HTMLDivElement).id === 'addToBasketButton') {
                addToCart(imgData, event);
            }

            if((event.target as Element).classList.contains("js-constructor-item-wrapper")) {
                // const newElementId = (event.target as Element).getAttribute('data-element-id');
                setBuyButtonText('Добавить в корзину');
            }
        };

        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, [...Object.values(imgData), ...Object.values(handFrameData), ...Object.values(backgroundData), price]);


    return (
        <div>
            <div className={`${styles.container} row`}>
                <div className={styles.buttonGroup}>
                    {/*<div className={styles.button} onClick={() => handleMakePDF(true)}>*/}
                    {/*    <DownloadIcon className={styles.downloadIcon}/>*/}
                    {/*    <span>Скачать ПДФ</span>*/}
                    {/*</div>*/}
                    <div className={styles.button} onClick={() => handleMakeWebLink()}>
                        <WebIcon className={styles.webIcon}/>
                        <span>Веб ссылка</span>
                    </div>
                    <div id={'js-hidden-make-weblink'} style={{ display: 'none' }}
                         onClick={() => handleMakeWebLinkToDataAttr()}></div>
                </div>

                <Modal
                    open={modalOpen}
                    aria-describedby="modal-modal-description"
                >
                    <Box className={styles.modalBoxContainer}>
                        <div className={styles.modalContainer}>
                            <div className={styles.modalBox}>
                                <div>
                                    Ссылка на конструктор с вашими настройками скопирована в буфер обмена
                                </div>
                                <div onClick={modalClose} className={styles.modalSubmitButton}>OK</div>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div>

            <AddToBasket
                text={buyButtonText}
                isLoading={addingToBasket}
                handleMakePDF={() => handleMakePDF(true)}
            />
        </div>
    );
}
